import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
// import Utils from '../../provisioning/utils.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { VcaAlertsService } from '../../../../common/vca-alerts';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { ReplaySubject } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/observable/from';
import { alphaNumericSort, limitdecimals } from '../../../../publisher/utils/utils';
import {environment} from '../../../../environments/environment';
import { HttpUtils } from 'common';
import { HttpClient } from '@angular/common/http';

export interface NspUpgradeData {
    cloudId: string;
    version: string;
    pairings: any[];
    availableVersions: any[]
}

@Injectable()
export class NspUpgradeService {

    public baseUrl = '';
    latestVersionForDownload : ReplaySubject<any> =  new ReplaySubject();
    private hcmReference = null;
    // stores all nsp upgrade data from data store
    private _nspData$: ReplaySubject<NspUpgradeData[]>;
    /// For Remote Data
    private _nspRemoteData$: ReplaySubject<NspUpgradeData[]>;
    // For Notifications
    private _nspNotifications$: ReplaySubject<any[]>;

    // stores all nspData fetched from DB
    private dataStore: {
        nspData: NspUpgradeData[],
        nspRemoteData: NspUpgradeData[],
        nspNotifications: any[]
    };

    public localHcspData: any;
    public localEndpoints: any;
    public localEndpointResources: any;

    public userUnauthorized: boolean = false;

    private devHmToken: string = null;
    private requestHeaders = null;
    private checkNotificationsPromise: any = null;
    private loadLocalUpgradeDataInvoked: boolean = false;
    private loadRemoteUpgradeDataInvoked: boolean = false;
    private waitFornspData: Promise<any> = null;

    constructor(public http: HttpClient, private alert: VcaAlertsService) {

        const path = ((window.location.pathname.match(/(.*)(\/publisher-ui)(\/.*|$)/) || [])[1] || '');
        this.baseUrl = (path !== '' && path !== '/hybridity/ui' && path !== '/hybridity/ui/service-1.0') ? path + '/hcx-ui/rest' : '';
        
        if(environment.loadedInVCRemotePlugin) {
            this.baseUrl = HttpUtils.getBaseUrl();
        }
        this.devHmToken = this.findGetParameter('devHmToken');
        this.requestHeaders = new Headers();
        this.requestHeaders.append('Accept', 'application/json');
        this.requestHeaders.append('Content-Type', 'application/json');
        !!this.devHmToken && this.requestHeaders.append('x-hm-authorization', this.devHmToken);
        this.dataStore = { nspData: [], nspRemoteData: [], nspNotifications: [] };
        this._nspData$ = new ReplaySubject() as ReplaySubject<NspUpgradeData[]>;
        this._nspRemoteData$ = new ReplaySubject() as ReplaySubject<NspUpgradeData[]>;
        this._nspNotifications$ = new ReplaySubject() as ReplaySubject<any[]>;

    }

    public queryHcmInstances(successCb, errorCb) {
        const me = this;
        const hcmReferenceObservable = Observable.create(function(observer) {
            const url = me.baseUrl + '/hybridity/api/metainfo/context/publisher';
            me.http.get(url, {headers: me.requestHeaders})
                .toPromise()
                .then((data:any) => {
                    !!data && !!data.data && !!data.data.localEndpoints &&
                        data.data.localEndpoints.forEach((reference) => observer.next(reference));
                    observer.complete();
                }).catch((error) => observer.error(error));
        });

        const subscription = hcmReferenceObservable.subscribe({
            next: (reference) => {
                // TODO: we should not capture only first vc, but should get data from all of them!
                if (!me.hcmReference && !!reference.hcsp && !!reference.hcsp.serverAddress) {
                    // retrofit structure (TODO: fix later)
                    reference.serverGuid = reference.resourceId;
                    reference.serverName = reference.resourceName;
                    me.hcmReference = reference;
                }
            },
            error: (err) => {
                setTimeout(() => !!subscription && subscription.unsubscribe(), 10);
                !!errorCb && errorCb();
            },
            complete: () => {
                setTimeout(() => !!subscription && subscription.unsubscribe(), 10);
                !!successCb && successCb();
            }
        });
    }

    public getLocalHcmReference() {
        return this.hcmReference;
    }

    // returns all nsp observer, it notifies if nsp array is changed
    get nspData() {
        return this._nspData$.asObservable();
    }

    get remoteNspData() {

        return this._nspRemoteData$.asObservable();
    }
    /**
      * load all NSP from DB by calling REST api and store it in data store
     **/
    public pollJobStatus(item, hcspUUID) {
        const me = this;
        let url = this.baseUrl + '/hybridity/api/upgrade?action=queryStatus';
        url = url + '&hcspUUID=' + hcspUUID; // XXX this is not good, to know item structure!
        return Observable.interval(10000)
            .switchMap(() => this.http.post(url, JSON.stringify(item), {headers: me.requestHeaders}))
            ;
    }

    public getJobStatus(item, hcspUUID) {
        const me = this;
        let url = this.baseUrl + '/hybridity/api/upgrade?action=queryStatus';
        url = url + '&hcspUUID=' + hcspUUID; // XXX this is not good, to know item structure!
        return this.http.post(url, JSON.stringify(item), {headers: me.requestHeaders});
    }

    public downloadBundle(siteinfo, hcspUUID): Observable<any> {
        const me = this;
        const payload = {
            endpointId: siteinfo.endpointId,
            version: siteinfo.version
        };
        let url = this.baseUrl + '/hybridity/api/upgrade?action=downloadBundle';
        url = url + '&hcspUUID=' + hcspUUID; // XXX this is not good, to know item structure!
        return this.http.post(url, JSON.stringify(payload), {headers: me.requestHeaders})
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    // poll for downloading OVA bundle
    public pollOvaBundleDownloadStatus(downloadId) {
        const me = this;
        const jobStatusUrl = `${this.baseUrl}/hybridity/api/downloads/${downloadId}?hcspUUID=${this.hcmReference.endpoint.uuid}`;
        return Observable.interval(10000)
            .switchMap(() => this.http.get(jobStatusUrl, { headers: me.requestHeaders }))
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    // get the downloadID for OVA file
    public downloadOvaBundleFile() {
        const me = this;
        const url = `${this.baseUrl}/hybridity/api/downloads?hcspUUID=${this.hcmReference.endpoint.uuid}`;

        const payload = {
            bundleType: 'HCX Enterprise',
            fileType: 'ova'
        };
        return this.http.post(url, JSON.stringify(payload), { headers: me.requestHeaders })
            .catch((error) => {
                return Observable.throw(error);
            });
        // if (!!this.hcmReference && !!this.hcmReference.serverGuid) {
        //     //Ignore if UI is HCM
        // } else {
        //     return this.http.post(url, JSON.stringify(payload), {headers: me.requestHeaders})
        //     .catch(error => {
        //         return Observable.throw(error);
        //     })
        // }

    }

    ////// Default Release Notes
    public getDefaultLocalReleaseNotes(hcspUUID = null) {
        const me = this;
        if (hcspUUID) {
            return me.getDefaultLocalReleaseNotesPromise(hcspUUID);
        } else {
            return me.getContext().then( (resp) => {
                const wait_list = [];

                let release_notes  = [];
                me.localHcspData.forEach((hcspInfo) => {
                    wait_list.push(new Promise((resolve, reject) => {
                        me.getDefaultLocalReleaseNotesPromise(hcspInfo.uuid).then( (resp:any) => {
                            if (resp.data && resp.data.items) {
                                for (const x in resp.data.items) {
                                    resp.data.items[x]._source = hcspInfo;
                                }
                            }
                            release_notes = release_notes.concat((resp.data && resp.data.items) || []);
                            resolve(true);
                        }).catch((err) => {
                            console.log('error in getting release notes ', err);
                            resolve(true);
                        });
                    }));
                });

                return Promise.all(wait_list).then((values) => {
                    return {data: {items: release_notes}}; // mimic data, returned by $http
                });
            });
        }
    }

    private getDefaultLocalReleaseNotesPromise(hcspUUID) {
        const me = this;

        let url = this.baseUrl + '/hybridity/api/hcspAppliances?';
        url = url + '&hcspUUID=' + hcspUUID;
        const payload = {
            action: 'queryBuildMetaData',
            filter: {
                local: true
            }
        };

        return this.http.post( url, JSON.stringify(payload), { headers: me.requestHeaders })
            .toPromise()
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    public doUpgradeNSP(item, hcspUUID) {
        const me = this;
        const payload = {
            endpointId: item.systemId,
            version: item.selectedVersion
        };
        let url = this.baseUrl + '/hybridity/api/upgrade?action=start';
        url = url + '&hcspUUID=' + hcspUUID;
        hcspUUID;
        return this.http.post(url, JSON.stringify(payload), {headers: me.requestHeaders})
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    public doScheduledUpgradeNSP(item, hcspUUID) {
        const me = this;
        const payload = {
            endpointId: item.systemId,
            version: item.selectedVersion,
            scheduleAt: item.scheduledDate
        };
        let url = this.baseUrl + '/hybridity/api/upgrade?action=start';
        url = url + '&hcspUUID=' + hcspUUID;
        return this.http.post( url, JSON.stringify(payload), {headers: me.requestHeaders})
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    public queryJobWithFilters(siteInfo, hcspUUID) {
        const me = this;
        // query only last upgrade status per NSP
        const filter = siteInfo;
        let url = this.baseUrl + '/hybridity/api/upgrade?action=queryStatus';
        url = url + '&hcspUUID=' + hcspUUID;
        return this.http.post( url, JSON.stringify(filter), {headers: me.requestHeaders})
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    public getAvailBundles(hcspUUID) {
        const me = this;
        let url = this.baseUrl + '/hybridity/api/upgrade/availableBundles?';
        url = url + '?hcspUUID=' + hcspUUID;
        return this.http.get(url, {headers: me.requestHeaders})
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    private localHcspDataPromise: any = null;
    public getContext(force = false) {
        const me = this;
        if (!me.localHcspDataPromise || force) {
            me.localHcspDataPromise = me.http.get(me.baseUrl + '/hybridity/api/metainfo/context/publisher', { headers: me.requestHeaders })
                .toPromise().then( (resp:any) => {
                    me.localEndpointResources = resp.data.localEndpoints;
                    me.localHcspData = [];
                    me.localEndpoints = [];
                    const known_hcsps = {};
                    const known_endpoints = {};
                    resp.data.localEndpoints.forEach((local_endpoint) => {
                        if (local_endpoint.hcsp && local_endpoint.hcsp.uuid && !known_hcsps[local_endpoint.hcsp.uuid]) {
                            me.localHcspData.push(local_endpoint.hcsp);
                            known_hcsps[local_endpoint.hcsp.uuid] = 1;
                        }
                        if (local_endpoint.endpoint && !known_endpoints[local_endpoint.endpoint.endpointId]) {
                            me.localEndpoints.push(local_endpoint.endpoint);
                            known_endpoints[local_endpoint.endpointId] = 1;
                        }
                    });
                    return resp;
                });
        }
        return me.localHcspDataPromise;
    }

    private locaAllNotifications_promise;
    public locaAllNotifications() {
        const me = this;
        if (me.locaAllNotifications_promise) { return me.locaAllNotifications_promise; }

        const wait_list = [];
        let local_notifications = [];

        me.locaAllNotifications_promise = me.getContext().then((resp) => {
            me.localHcspData.forEach((hcspInfo) => {
                wait_list.push(new Promise((resolve, reject) => {
                    me.getCheckNotificationsPromise(hcspInfo.uuid).then( (resp) => {
                        if (resp.data && resp.data.items) {
                            for (const x in resp.data.items) {
                                resp.data.items[x]._source = hcspInfo;
                            }
                        }
                        local_notifications = local_notifications.concat((resp.data && resp.data.items) || []);
                        resolve(true);
                    }).catch((err) => {
                        // TODO: log error...
                        //console.log('error in notifications', err);
                        resolve(true); // (!) Never fail! or "Promise.all" (in code below) will fail...
                    });
                }));
            });

            return Promise.all(wait_list).then((values) => {
                me.dataStore.nspNotifications = local_notifications;
                me._nspNotifications$.next(local_notifications);

                return {data: {items: me.dataStore.nspNotifications}}; // mimic data, returned by $http
            });
        });

        return me.locaAllNotifications_promise;
    }

    private loadAllNspUpgradeData_promise;
    public loadAllNspUpgradeData() {

        // 1. get context (/hybridity/api/metainfo/context/publisher)
        // 2. collect hcsp from each of localEndpoints
        // 4. (!) remember this list (it will be used for each API call !)
        // 3. prepare a list of promises of call to each of hcsp for data and collect all results
        // 4. provide own response as collected result when all promises are ready
        const me = this;
        if (me.loadAllNspUpgradeData_promise) { return me.loadAllNspUpgradeData_promise; }

        const wait_list = [];
        let local_appliances = [];

        wait_list.push( me.locaAllNotifications() );
        me.loadAllNspUpgradeData_promise = me.getContext().then((resp) => {
            // request data from each of dat/API providers (this is a key feature for linked mode support!)
            me.localHcspData.forEach((hcspInfo) => {
                wait_list.push(new Promise((resolve, reject) => {
                    me.getHcspAppliacncesPromise(hcspInfo.uuid, 'local').then( (resp:any) => {
                        if (resp.data && resp.data.items) {
                            for (const x in resp.data.items) {
                                resp.data.items[x]._source = hcspInfo;
                            }
                        }
                        local_appliances = local_appliances.concat((resp.data && resp.data.items) || []);
                        resolve(true);
                    }).catch((err) => {
                        // TODO: log error!
                        console.log('error in load data', err);
                        resolve(true); // (!) Never Fail!
                    });
                }));
            });

            // wait_list = [me.getCheckNotificationsPromise(), getLocalHcspAppliacncesPromise()];
            return Promise.all(wait_list).then((values) => {
                // here we update dataStore with data, collected from all of local data/api providers

                for (const x in local_appliances) {
                    const app = local_appliances[x];
                    app.availableBundles = app.availableBundles || [];
                    app.availableBundlesObjects = app.availableBundlesObjects || [];

                    for (const y in me.dataStore.nspNotifications) {
                        const notification = me.dataStore.nspNotifications[y];

                        // XXX we should probably check whether appliance & notification came from the same "hscp" (API source)
                        if (app.systemId === notification.endpointId) {
                            notification.showNewBuildTag = false;
                            app.availableBundles.push(notification);
                            app.availableBundlesObjects.push({
                                bundle: notification.version,
                                date: 'date TBA',
                                externalReleaseNote: notification.externalReleaseNote
                            });
                        }
                    }
                    // normalize available upgrade bundle data before storing to store.
                    me.normalizeAvailableUpgradeBundlesDataList(app);
                }                                                                 
                me.dataStore.nspData = local_appliances;
                me._nspData$.next(local_appliances);

                return {data: {items: me.dataStore.nspData}}; // mimic data, returned by $http
            }).catch(function(error) {
                if (error.status === '403') {
                    me.userUnauthorized = true;
                }
            });
        });

        return me.loadAllNspUpgradeData_promise;
    }

    /* This fn will process all the upgrade bundles avialable for hcx system and
    * determine the most recent build and most recent build with same major ver. number of current hcx system
    * and sort them to top and mark them as builds to be shown with 'NEW' build label.
    * The rest of the upgrade bundles will sorted in order of major.minor.update.patch
    * e.g. if builds available are "5.1.0.12323212", "4.0.5.87654321", "5.0.0.12345678", "6.0.0.0","4.2.3.21345678"
    * and hcx system currently at ver. 4.0.0.12345678
    * then builds "6.0.0.0" and "4.2.3.21345678" will be marked NEW
    * */
    public normalizeAvailableUpgradeBundlesDataList(applianceData) {
        let currentVersion = applianceData.version || '';
        let avaialbleDowngradableVersions = [];
        
        if (applianceData && applianceData.availableBundles && applianceData.availableBundles.length > 0) {
            // sort all the bundles by major.minor.update.patch
            applianceData.availableBundles.sort((bundleA, bundleB) => {
                let d = [bundleA.version, bundleB.version];
                d = this.sortSemverStrings(d);
                return (bundleA.version === bundleB.version) ? 0 : (d[0] === bundleA.version) ? 1 : -1;
            });
          
            applianceData.availableBundles.forEach(bundle=>{
                if(this.convertSemverStringToVersionObject(bundle.version).major === this.convertSemverStringToVersionObject(currentVersion).major){
                    bundle.isUpgradeable = true;
                    avaialbleDowngradableVersions.push(bundle.version);
                } else if(((+this.convertSemverStringToVersionObject(bundle.version).major) === (+this.convertSemverStringToVersionObject(currentVersion).major) + 1) && (+this.convertSemverStringToVersionObject(bundle.version).minor) === 0){ //parse int and check with number 0
                    // when the build major version is the next immediate major version from that of the current major version and the minor version is zero. -- ex: when the current version is 4.X.X.X, the last upgradable version would be 5.0.X.X
                    bundle.isUpgradeable = true;
                    avaialbleDowngradableVersions.push(bundle.version);
                }
            });
            if(avaialbleDowngradableVersions && avaialbleDowngradableVersions.length){
                this.latestVersionForDownload.next(limitdecimals(avaialbleDowngradableVersions[0], '.', 4));
            }
            // find most recent build
            const mostRecentBuild = this.findMostRecentBuild(applianceData.availableBundles);
            const mostRecentBuildIndex = applianceData.availableBundles.findIndex((bundle) => bundle.version === mostRecentBuild.version);
            // find most recent build with same major ver. number of current hcx system
            const mostRecentBuildToCurrentSystemMajorVersion = this.findMostRecentBuildToCurrentSystemMajorVersion(applianceData.availableBundles, applianceData.version);
            const mostRecentBuildToCurrentSystemMajorVersionIndex = mostRecentBuildToCurrentSystemMajorVersion ? applianceData.availableBundles.findIndex((bundle) => bundle.version === mostRecentBuildToCurrentSystemMajorVersion.version) : -1;

            applianceData.availableBundles.splice(mostRecentBuildIndex, 1);
            // if mostRecentBuildToCurrentSystemMajorVersion and mostRecentBuild are same then no processing needed
            // if mostRecentBuildToCurrentSystemMajorVersion not present np processing needed.
            if (mostRecentBuildToCurrentSystemMajorVersionIndex !== -1 &&
                mostRecentBuildIndex !== mostRecentBuildToCurrentSystemMajorVersionIndex &&
                this.convertSemverStringToVersionObject(mostRecentBuild.version).major !== this.convertSemverStringToVersionObject(mostRecentBuildToCurrentSystemMajorVersion.version).major) {
                applianceData.availableBundles.splice(mostRecentBuildToCurrentSystemMajorVersionIndex - 1, 1);
                // mark build to be shown as NEW in UI
                mostRecentBuildToCurrentSystemMajorVersion.showNewBuildTag = true;
                // push build to top of list
                applianceData.availableBundles.unshift(mostRecentBuildToCurrentSystemMajorVersion);

            }
            // mark build to be shown as NEW in UI
            mostRecentBuild.showNewBuildTag = true;
            // push build to top of list
            applianceData.availableBundles.unshift(mostRecentBuild);
            // update availableBundlesObjects data model also
            applianceData.availableBundlesObjects = [];
            applianceData.availableBundles.forEach((notification) => {
                notification['originalVersion'] = notification.version || '' ;
                notification.version = limitdecimals(notification.version, '.' ,4);
                applianceData.availableBundlesObjects.push({
                    originalVersion:notification.originalVersion,
                    bundle: notification.version,
                    date: 'date TBA',
                    externalReleaseNote: notification.externalReleaseNote
                });
            });
        }
    }

    public findMostRecentBuild(availableBundles) {
        let versionsAvailable = availableBundles.map((bundle) => bundle.version);
        versionsAvailable = this.sortSemverStrings(versionsAvailable);

        const latestBuild = versionsAvailable[versionsAvailable.length - 1];
        return availableBundles.find((bundle) =>  bundle.version === latestBuild);
    }

    public findMostRecentBuildToCurrentSystemMajorVersion(availableBundles, currentHcxSystemVersion) {
        let versionsAvailable = availableBundles.map((bundle) => bundle.version);
        versionsAvailable = this.sortSemverStrings(versionsAvailable);

        let buildsWithMajorVerSameAsHcxSystem = [];
        const currentHcxSystemVersionObject = this.convertSemverStringToVersionObject(currentHcxSystemVersion);
        // find all builds with major ver. same as current hcx system major ver.
        versionsAvailable.forEach((ver) => {
            const verObj = this.convertSemverStringToVersionObject(ver);
            if (verObj.major === currentHcxSystemVersionObject.major) {
                buildsWithMajorVerSameAsHcxSystem.push(ver);
            }
        });
        // there is no new upgrade bundle with same major ver. as of current hcx system majore ver.
        if (buildsWithMajorVerSameAsHcxSystem.length === 0) {
            return null;
        }
        buildsWithMajorVerSameAsHcxSystem = this.sortSemverStrings(buildsWithMajorVerSameAsHcxSystem);
        const latestBuild = buildsWithMajorVerSameAsHcxSystem[buildsWithMajorVerSameAsHcxSystem.length - 1];
        return availableBundles.find((bundle) =>  bundle.version === latestBuild);
    }

    /*
    * This fn will accept array of semver string e.g. major.minor.update.patch
    * and sort them in descending order
    * */
    public sortSemverStrings(arr) {
        let sortedVersionArr= alphaNumericSort(arr);
        return sortedVersionArr;
    }
    // Kept the old sorting mechanism for reference incase of need to revert the code
    // public sortSemverStrings(verStrings) {
    //     // our patch numbers are 8 digits long.If tomorrow increases length then adjust this accordingly to sort correctly.
    //     const patchNumberVarSeed = 100000000;
    //     return verStrings.map( (verStr) => verStr.split('.').map( (num) => +num + patchNumberVarSeed ).join('.') ).sort()
    //         .map( (verStr) => verStr.split('.').map( (num) => +num - patchNumberVarSeed ).join('.') );

    // This fn will accept a semver string and return semver object
    public convertSemverStringToVersionObject(semverString) {
        if (semverString) {
            const versionItems = semverString.trim().split('.');
            return {
                major: versionItems[0] || null,
                minor: versionItems[1] || null,
                update: versionItems[2] || null,
                patch: versionItems[3] || null
            };
        }
        return null;
    }

    public getHcspAppliacncesPromise(hcspUUID, isLocal) {
        const me = this;
        const payload = {
            action: 'query',
            paging: {
                offset: 'x',
                pageSize: 'y'
            },
            filter: {
                local: !!isLocal// ? "true" : "false" // XXX why do we have quotas here??!
            }
        };
        let url = this.baseUrl + '/hybridity/api/hcspAppliances?';
        url = url + '&hcspUUID=' + hcspUUID;
        return me.http.post( url, payload, { headers: me.requestHeaders })
            .toPromise();
    }

    private loadAllRemoteNspUpgradeData_promise;
    public loadAllRemoteNspUpgradeData() {
        // 1. get context (/hybridity/api/metainfo/context/publisher)
        // 2. collect hcsp from each of localEndpoints
        // 4. (!) remember this list (it will be used for each API call !)
        // 3. prepare a list of promises of call to each of hcsp for data and collect all results
        // 4. provide own response as collected result when all promises are ready
        const me = this;
        if (me.loadAllRemoteNspUpgradeData_promise) { return me.loadAllRemoteNspUpgradeData_promise; }

        let notificationData;
        let nspPreMergeData;
        const remoteHcspData = null;

        const wait_list = [];
        let remote_appliances = [];

        wait_list.push(me.locaAllNotifications());

        me.loadAllRemoteNspUpgradeData_promise = me.getContext().then((resp) => {

            // request data from each of dat/API providers (this is a key feature for linked mode support!)
            me.localHcspData.forEach((hcspInfo) => {
                wait_list.push(new Promise((resolve, reject) => {
                    me.getHcspAppliacncesPromise(hcspInfo.uuid, false).then( (resp:any) => {
                        if (resp.data && resp.data.items) {
                            for (const x in resp.data.items) {
                                resp.data.items[x]._source = hcspInfo;
                            }
                        }
                        remote_appliances = remote_appliances.concat((resp.data && resp.data.items) || []);
                        resolve(true);
                    }).catch((err) => {
                        // TODO: log error!
                        console.log('error in remote nsp upgrade', err);
                        resolve(true); // (!) Never Fail!
                    });
                }));
            });

            return Promise.all(wait_list).then(function(values) {

                for (const x in remote_appliances) {
                    const app = remote_appliances[x];
                    app.availableBundles = app.availableBundles || [];
                    app.availableBundlesObjects = app.availableBundlesObjects || [];

                    for (const y in me.dataStore.nspNotifications) {
                        const notification = me.dataStore.nspNotifications[y];

                        // XXX we should probably check whether appliance & notification came from the same "hscp" (API source)
                        if (app.systemId === notification.endpointId) {
                            app.availableBundles.push(notification);
                            app.availableBundlesObjects.push({
                                bundle: notification.version,
                                date: 'date TBA',
                                externalReleaseNote: notification.externalReleaseNote
                            });
                        }
                    }
                }

                me.dataStore.nspRemoteData = remote_appliances; // this should contain only remote systems info....
                me._nspRemoteData$.next(remote_appliances);

                return {data: {items: me.dataStore.nspData}}; // mimic data, returned by $http
            }).catch(function(error) {
            // console.log('Could not load Remote NSP info')
            });
        });
        return me.loadAllRemoteNspUpgradeData_promise;
    }

    public getCheckNotificationsPromise(hcspUUID) {
        const me = this;
        if (me.checkNotificationsPromise == null) { me.checkNotificationsPromise = {}; }
            // query only last upgrade status per NSP
        const tmpData = {};
        const filter = {
            endpointId: '',
            version: ''
        };
        let url = this.baseUrl + '/hybridity/api/upgrade?action=getNotifications';
        url = url + '&hcspUUID=' + hcspUUID;
        me.checkNotificationsPromise[hcspUUID] = this.http.post(url, JSON.stringify(filter), { headers: me.requestHeaders })
            .catch((error) => {
                if (error.status === '404') {
                    this.alert.info('User is not authorized to access Administration');
                }
                return Observable.throw(error);
            }).toPromise();
        return me.checkNotificationsPromise[hcspUUID];
    }

    public notifyUpgradeMessage() { // test for passinf service data
        const upgradeMessage = Observable.from(this._nspData$);
        return upgradeMessage;
    }

    private findGetParameter(parameterName) {
        let result = null, tmp = [];
        location.search.substr(1).split('&').forEach(function(item) {
            tmp = item.split('=');
            if (tmp[0] === parameterName) { result = decodeURIComponent(tmp[1]); }
        });
        return result;
    }

    ////// Administration Message  in case admin messages need to be polled
  /*  pollAdministrationMessages() {
        const me = this;
        let url = "/hybridity/api/alertMessages";
        return Observable.interval(10000)
            .switchMap(() => this.http.get(url, { headers: me.requestHeaders }))
            .catch(error => {
                return Observable.throw(error);
            });
    } */

    public pollAdministrationMessages() {
        const me = this;
        const o = Observable.defer(function() { return me.getAdministrationMessagesPromise(); });
        return o;
    }

    public getAdministrationMessagesPromise() {
        const me = this;

        const url = this.baseUrl + '/hybridity/api/alertMessages';

        const wait_list = [];
        const all_messages = [];
        const errors = [];
        const loadAllAdministrationMessages_promise = me.getContext().then((resp) => {
            // request data from each of dat/API providers (this is a key feature for linked mode support!)
            me.localHcspData.forEach((hcspInfo) => {
                wait_list.push(new Promise((resolve, reject) => {
                    me.http.get(url + '?hcspUUID=' + hcspInfo.uuid, {headers: me.requestHeaders})
                    .map((response:any) => {
                        const resp = response;
                        if (resp && resp.data && resp.data.messages) {
                            resp.data.messages.forEach((m) => {
                                m._source = hcspInfo;
                                all_messages.push(m);
                            });
                        }
                        resolve(resp);
                        return resp;
                    })
                    .catch((error) => {
                        // return Observable.throw(error);
                        errors.push({ error, hcspInfo});
                        resolve(true);
                        return null;
                    }).subscribe((x) => 1);
                }));
            });

            return Promise.all(wait_list).then(function(values) {
                return {success: true, data: {messages: all_messages}, errors};
            });

        });

        return loadAllAdministrationMessages_promise;
    }

    checkForUpgrade(hcspUUID) {
        let url = this.baseUrl +  '/hybridity/api/upgrade?action=checkForUpgrade'
        if(hcspUUID){
            url = url + '&hcspUUID=' + hcspUUID;
        }
        const body = {};
       return this.http.post(url,body).toPromise();
    }

    downloadUpgradeLogs(hcspUUID) {
        let url = this.baseUrl +  '/hybridity/api/upgrade/logs';
        if(hcspUUID){
            url += '?hcspUUID=' + hcspUUID;
        }
        return this.http.get(url, {observe: 'response', responseType: 'blob'});
    }

    
    public pollUpgradeTasks(jobId, hcspUUID) {
        const me = this;
        let url =  this.baseUrl + '/hybridity/api/upgrade/checkForUpgradeTasks/'+jobId
        if(hcspUUID) {
            url = url + '?hcspUUID=' + hcspUUID;
        }
        const body = {};
        return Observable.interval(10000)
            .switchMap(() => this.http.get(url,body)
            .catch((error) => {
                return Observable.throw(error);
            }));
    }

    public checkApplianceUpgradeSchedule () {
        const url = this.baseUrl +  '/hybridity/api/applianceUpgradeSchedule '
        const body = {};
       return this.http.get(url,body);
    }

}



// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/upgrade/nsp-upgrade.service.ts